import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { Crumbs } from "@/components/content/ContentBits";

const STANDARDS = [
  "Every Etsy fact we state (13 tags, 20 characters per tag, 140-character titles, Etsy's 2025 title guidance) is checked against Etsy's Help Center and Seller Handbook, and linked.",
  "Every tag set is checked automatically: exactly 13 tags, each 20 characters or fewer, no duplicates. Every example title is 140 characters or fewer.",
  "We never claim search volumes, rankings or sales results, and we never invent statistics or testimonials.",
  "Pages are drafted with AI from a detailed brief, then pass an automated quality gate and an editorial review before publishing.",
  "Tag ideas are starting points. Validate them against your own research and Etsy Stats.",
];

export default function About() {
  return (
    <PublicLayout>
      <article data-testid="about-page" className="mx-auto max-w-3xl px-5 py-10 sm:px-8 sm:py-14">
        <Crumbs testid="about-breadcrumbs" items={[["Home", "/"], ["About"]]} />
        <h1 className="font-display text-4xl leading-[1.08] sm:text-5xl">About AetherTags</h1>
        <div className="mt-8 space-y-5 text-[17px] leading-[1.75] text-muted-foreground">
          <p>AetherTags is an Etsy SEO tool for big catalogs, built by a small founder-led team for print-on-demand, vintage and handmade shops with hundreds or thousands of listings.</p>
          <p>It reads your listings through Etsy's official API, scores every one, drafts title, tag and attribute fixes with a reason for each change, locks your bestsellers, and pushes nothing without your approval. Every change can be undone in one click, and edited listings are compared with untouched ones so you can see what changed.</p>
          <h2 className="pt-6 font-display text-2xl text-foreground sm:text-3xl">How we write our guides</h2>
          <p>The guides and Etsy tag pages are written by the AetherTags Team for sellers who want specific, usable answers rather than generic tips.</p>
          <ul data-testid="about-standards" className="list-disc space-y-2 pl-5 marker:text-[#E9C98B]/70">{STANDARDS.map((s) => <li key={s}>{s}</li>)}</ul>
          <h2 className="pt-6 font-display text-2xl text-foreground sm:text-3xl">Independent from Etsy</h2>
          <p>The term "Etsy" is a trademark of Etsy, Inc. AetherTags uses the Etsy API but is not endorsed or certified by Etsy, Inc.</p>
          <p className="pt-4">
            <Link to="/blog" data-testid="about-guides-link" className="text-[#5EE6D0] underline underline-offset-4">Read the guides</Link> ·{" "}
            <Link to="/etsy-tags" data-testid="about-tags-link" className="text-[#5EE6D0] underline underline-offset-4">Browse Etsy tags by product</Link>
          </p>
        </div>
      </article>
    </PublicLayout>
  );
}
